import BotPreviewTemplate from './BotPreviewTemplate'

export default BotPreviewTemplate
